export default __webpack_public_path__ + "static/media/96C9E6D7-22E0-4036-BCD7-73D35B7E2BCA_1_105_c.7d99ed3d.jpg";